import React, { useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ParceirosPage() {
  const [form, setForm] = useState({ sindicato: "", cidade: "", uf: "", responsavel: "", whatsapp: "", datas: "", observacoes: "" });
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [stats, setStats] = useState(null);

  useEffect(() => {
    axios.get(`${API}/public/stats`).then((r) => setStats(r.data)).catch(() => {});
  }, []);

  const setField = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setSending(true);
    try {
      await axios.post(`${API}/parceiros/curso`, form);
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.detail || "Erro ao enviar. Tente novamente.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-green-800 to-green-950 py-8 px-4" data-testid="parceiros-page">
      <div className="max-w-lg mx-auto">
        <div className="text-center mb-6">
          <img src="/icon-192x192.png" alt="HeveaTalent" className="w-16 h-16 rounded-2xl mx-auto shadow-lg" />
          <h1 className="text-2xl md:text-3xl font-bold text-white mt-4">Sindicato parceiro HeveaTalent</h1>
          <p className="text-green-200 mt-2 text-sm">
            Nós divulgamos seu curso de sangria <strong className="text-white">de graça</strong> e seus alunos
            saem do curso com acesso direto às vagas das fazendas.
          </p>
        </div>

        <div className="bg-green-950/70 border border-green-600/50 rounded-xl px-4 py-3 mb-4 text-white text-xs sm:text-sm space-y-1.5" data-testid="parceiros-beneficios">
          <p>✅ Divulgação gratuita na página <b className="text-amber-300">heveatalent.com.br/cursos</b> e nos grupos</p>
          <p>✅ QR Code pronto para a sala de aula — aluno se cadastra na hora</p>
          <p>✅ Seus alunos ganham o selo 🎓 e aparecem para as fazendas que contratam</p>
          {stats && <p>✅ {stats.active_jobs} vaga{stats.active_jobs !== 1 ? "s" : ""} ativa{stats.active_jobs !== 1 ? "s" : ""} e {stats.employers} produtor{stats.employers !== 1 ? "es" : ""} na plataforma hoje</p>}
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-5">
          {done ? (
            <div className="text-center py-6" data-testid="parceiros-success">
              <div className="text-5xl mb-3">🎉</div>
              <h2 className="text-xl font-bold text-green-800">Curso recebido!</h2>
              <p className="text-gray-600 mt-2 text-sm">
                Nossa equipe vai revisar e publicar na página de cursos. Entraremos em contato pelo WhatsApp informado.
              </p>
              <button
                onClick={() => { setDone(false); setForm({ sindicato: "", cidade: "", uf: "", responsavel: "", whatsapp: "", datas: "", observacoes: "" }); }}
                className="mt-5 w-full py-3 rounded-xl bg-green-700 text-white font-semibold hover:bg-green-800"
                data-testid="parceiros-send-another"
              >
                Enviar outro curso
              </button>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-3">
              <h2 className="font-bold text-gray-800">Cadastre seu curso de sangria</h2>
              <div>
                <label className="text-xs font-semibold text-gray-600">Sindicato / Instituição *</label>
                <input className="w-full border rounded-lg px-3 py-2 text-sm mt-1" placeholder="Ex: Sindicato Rural de Votuporanga"
                  value={form.sindicato} onChange={(e) => setField("sindicato", e.target.value)} data-testid="parceiros-sindicato" />
              </div>
              <div className="grid grid-cols-3 gap-2">
                <div className="col-span-2">
                  <label className="text-xs font-semibold text-gray-600">Cidade do curso *</label>
                  <input className="w-full border rounded-lg px-3 py-2 text-sm mt-1" placeholder="Ex: Votuporanga"
                    value={form.cidade} onChange={(e) => setField("cidade", e.target.value)} data-testid="parceiros-cidade" />
                </div>
                <div>
                  <label className="text-xs font-semibold text-gray-600">UF</label>
                  <input className="w-full border rounded-lg px-3 py-2 text-sm mt-1" placeholder="SP" maxLength={2}
                    value={form.uf} onChange={(e) => setField("uf", e.target.value.toUpperCase())} data-testid="parceiros-uf" />
                </div>
              </div>
              <div>
                <label className="text-xs font-semibold text-gray-600">Nome do responsável</label>
                <input className="w-full border rounded-lg px-3 py-2 text-sm mt-1" placeholder="Ex: Solange"
                  value={form.responsavel} onChange={(e) => setField("responsavel", e.target.value)} data-testid="parceiros-responsavel" />
              </div>
              <div>
                <label className="text-xs font-semibold text-gray-600">WhatsApp para inscrições *</label>
                <input className="w-full border rounded-lg px-3 py-2 text-sm mt-1" placeholder="(17) 99999-9999"
                  value={form.whatsapp} onChange={(e) => setField("whatsapp", e.target.value)} data-testid="parceiros-whatsapp" />
              </div>
              <div>
                <label className="text-xs font-semibold text-gray-600">Datas do curso (se já confirmadas)</label>
                <input className="w-full border rounded-lg px-3 py-2 text-sm mt-1" placeholder="Ex: 14 a 16/10/2026"
                  value={form.datas} onChange={(e) => setField("datas", e.target.value)} data-testid="parceiros-datas" />
              </div>
              <div>
                <label className="text-xs font-semibold text-gray-600">Observações</label>
                <textarea className="w-full border rounded-lg px-3 py-2 text-sm mt-1" rows={2}
                  placeholder="Local, nº de vagas, outros detalhes…"
                  value={form.observacoes} onChange={(e) => setField("observacoes", e.target.value)} data-testid="parceiros-obs" />
              </div>
              {error && <p className="text-sm text-red-600" data-testid="parceiros-error">{error}</p>}
              <button type="submit" disabled={sending}
                className="w-full py-3 rounded-xl bg-green-700 text-white font-bold hover:bg-green-800 disabled:opacity-60"
                data-testid="parceiros-submit">
                {sending ? "Enviando…" : "📤 Enviar curso para divulgação gratuita"}
              </button>
              <p className="text-[11px] text-gray-400 text-center">
                A publicação passa por revisão da equipe HeveaTalent. A inscrição dos alunos continua sendo feita com você.
              </p>
            </form>
          )}
        </div>

        <p className="text-center mt-4">
          <a href="/cursos" className="text-green-200 underline text-sm" data-testid="parceiros-ver-cursos">Ver cursos publicados →</a>
        </p>
      </div>
    </div>
  );
}
